export const CREATE_SUCCESS_VIDEO_SUCCESS = "success_video/create_success_video_success";
export const CREATE_SUCCESS_VIDEO_FAIL = "success_video/create_success_video_fail";

export const UPDATE_SUCCESS_VIDEO_SUCCESS = "success_video/update_success_video_success";
export const UPDATE_SUCCESS_VIDEO_FAIL = "success_video/update_success_video_fail";

export const GET_SUCCESS_VIDEO_SUCCESS = "success_video/get_success_video_success";
export const GET_SUCCESS_VIDEO_FAIL = "success_video/get_success_video_fail";

export const DELETE_SUCCESS_VIDEO_SUCCESS = "success_video/delete_success_video_success";
export const DELETE_SUCCESS_VIDEO_FAIL = "success_video/delete_success_video_fail";